<template>
    <div>
        <div class="detail-bottom-bar" v-if="productId">
            <a href="javascript:;" class="item" @click="telPoup()" v-show="(shop && shop.onlineCustomServiceUrl) || (shop && shop.servicePhoneList && shop.servicePhoneList.length)">
                <i class="icon-retail-customer-service"></i>
                <span>客服</span>
            </a>
            <a href="javascript:;" class="item" @click="goShop()" v-show="shop && shop.shopMUrl && !isHideShop">
                <i class="icon-retail-shop"></i>
                <span>店铺</span>
            </a>
            <a href="javascript:;" class="item" @click="upper" v-if="showAllBtnAndPoster">
                <i class="sj"></i>
                <span>上架</span>
            </a>
            <template v-else>
                <a v-if="displayCollected && status === 1" href="javascript:;" class="item" @click="deleteFavorite">
                    <i :class="{'icon-retail-star-click': true, 'collection-animate':pageCollected}"></i>
                    <span>收藏</span>
                </a>
                <a v-else-if="status === 1" href="javascript:;" class="item" @click="eventTrack('CLICK_INDEX_BOTTOM_COLLECT');addFavorite()">
                    <i class="icon-retail-collection"></i>
                    <span>收藏</span>
                </a>
            </template>
            <div v-if="supportGroupBuying" class="group-buying">
                <a href="javascript:;" class="single" :class="{disabled: status !== 1}" @click="groupSubmit(false)">
                    <span class="single-price" v-if="status === 1">¥{{startPrice}}<span class="qi" v-if="multiPackage">起</span></span>
                    <span class="single-desc">单独购买</span>
                </a>
                <a href="javascript:;" class="group" :class="{disabled: status !== 1}" @click="groupSubmit(true)">
                  <span class="group-price" v-if="status === 1">¥{{groupStartPrice}}<span class="qi" v-if="multiPackage">起</span></span>
                  <span class="group-desc">拼团<span v-if="groupActivity.purchaseLimit && groupActivity.joinTime <= 999 && !multiPackage">(限购{{groupActivity.joinTime}}件)</span></span>
                </a>
            </div>
            <div class="submit-share" v-else-if="showAllBtnAndPoster">
                <a href="javascript:;" class="left-submit" :class="{long: prdTmpId === 8}" @click="submit">{{ (baseInfo.classBrandParentId === 56 || prdTmpId === 8) ? '代客订·自购' : '购买' }}</a>
                <a href="javascript:;" class="right-share" @click="share">分享</a>
            </div>
            <a href="javascript:;" :class="{submit: true, disabled: status !== 1 || baseInfo.head.saleEmpty === 1 || baseInfo.notSale}" @click="submit" v-else>
                <span>{{ baseInfo.notSale ? '不可预订' : baseInfo.head.saleEmpty === 1 ? '售罄' : '立即预订'}}</span>
            </a>
            <Popup :show="showTelPoup" :title="'客服'" :buttons="[]" class="tel-popup" v-if="(shop && shop.onlineCustomServiceUrl) || (shop && shop.servicePhoneList && shop.servicePhoneList.length)">
                <div class="tel-tip" v-for="(item, index) in shop.servicePhoneList" v-if="item.masterPhoneNumber" :key="index">
                    <a class="white" href="javascript:;" @click="makeAppCall(item.masterPhoneNumber + (item.slavePhoneNumber ? ',' + item.slavePhoneNumber : ''))">
                        {{item.description}}<span>{{item.masterPhoneNumber}} <span v-if="item.slavePhoneNumber">转&nbsp;{{item.slavePhoneNumber}}</span></span>
                    </a>
                </div>
                <div class="tel-tip" v-if="shop && shop.onlineCustomServiceUrl"><a :href="shop.onlineCustomServiceUrl"><i class="icon-retail-customer-service"></i>在线客服</a></div>
            </Popup>
            <div class="collection-tips" v-if="favoriteMsg"><p>{{favoriteMsg}}</p></div>
            <div class="notice" v-if="supportGroupBuying && showNotice && status === 1 && prdTmpId != 8">
              <span class="text">人满发货，人不满自动退款</span>
              <div class="close-wrap" @click="closeNotice">
                <div class="close"></div>
              </div>
            </div>
        </div>
        <div class="detail-bottom-bar" v-else>产品productId为{{ productId }}</div>
        <div class="not-for-sale" v-if="baseInfo.status === 0 || baseInfo.head.saleEmpty === 1 || baseInfo.notSale">{{tipsShow}}</div>
    </div>
</template>

<script>
import Popup from '@/components/Popup';
import { eventTrack } from '@/business/analy';
import { addFavoriteP, deleteFavoriteP } from 'create-api';
import { versionCmp, isIOS11App } from '@/business/global';
import { mapGetters } from 'vuex';
const LOGIN_URL = '/u/login';

export default {
    name: 'bottomBar',
    data() {
        return {
            showTelPoup: {isShow: false},
            pageCollected: null,
            favoriteMsg: '',
            showNotice: true
        }
    },
    props: {
        status: {
            type: Number,
            default: 1
        },
        shop: {
            type: Object,
            default: function () {
                return {}
            }
        },
        collected: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        productId: {
            type: Number,
            default: function () {
                return 0
            }
        },
        startPrice: {
            type: Number,
            default: function () {
                return 0
            }
        },
        prdTmpId: {
            type: Number,
            default: function () {
                return 3
            }
        },
        isApp: {
            type: Boolean,
            default: false
        },
        isHideShop: {
            type: Boolean,
            default: false
        },
        supportGroupBuying: {
          type: Boolean,
          default: false
        },
        groupActivity: {
          type: Object,
          default: () => ({})
        },
        isGroupBuying: {
          type: Boolean,
          default: false
        },
        showAllBtnAndPoster: {
            type: Boolean,
            default: false
        },
        shareImageData: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        Popup
    },
    computed: {
        ...mapGetters('derivativePackage', [
            'multiPackage',
            'groupStartPrice'
        ]),
        displayCollected: function() {
            return this.pageCollected !== null ? this.pageCollected : this.collected;
        },
        baseInfo() {
            return (this.$store.state.detail && this.$store.state.detail.baseInfo) || {};
        },
        tipsShow() {
            if (this.baseInfo.notSale) {
                return '此产品暂不可售卖';
            }else if (this.baseInfo.head.saleEmpty === 1) {
                return this.baseInfo.head.saleEmptyTips || '产品已售罄，你可能喜欢推荐产品';
            } else {
                return '产品已下架';
            }
        }
    },
    mounted() {
        try {
            this.updateDetailBottomBarPosition();
            window.addEventListener('resize', this.updateDetailBottomBarPosition);
            
        } catch (error) {
            console.log('初始化底部位置报错1 error',error);
        }
        
    },
    beforeDestroy() {
        try {
            window.removeEventListener('resize', this.updateDetailBottomBarPosition);  
        } catch (error) {
            console.log('销毁初始化底部位置报错2 error',error);
        }
        

    },
    methods: {
        updateDetailBottomBarPosition() {
            try {
                // 设置元素的定位属性为fixed
                this.$el.querySelector('.detail-bottom-bar').style.position = 'fixed';
                // 设置元素距离底部的位置为0
                this.$el.querySelector('.detail-bottom-bar').style.bottom = '0';
                
            } catch (error) {
                console.log('初始化底部位置报错 error',error);
                
            }      
        },
        goShop () {
            if (this.shop && this.shop.shopMUrl) {
                eventTrack('CLICK_INDEX_SHOP');
                window.location.href = this.isApp && isIOS11App() ? `tuniuapp://page?iosPageName=TNReactNativeViewController&androidPageName=com.tuniu.app.ui.activity.TNReactNativeActivity&parameters={"rctModule":"tnmall","rctModuleName":"mallShopRoutes","rctModuleParams":{"shopId":` + (this.shop && this.shop.shopId) + `}}` : this.shop.shopMUrl;
            }
        },
        telPoup () {
            this.showTelPoup = {isShow: true};
        },
        submit () {
            if (this.status !== 1 || this.baseInfo.head.saleEmpty === 1 || this.baseInfo.notSale) return;
            eventTrack('CLICK_INDEX_BOTTOM_SUBMIT');
            if (this.prdTmpId === 3) {  //0为老模板，其他为新模板
                this.showPackagePopup();
            } else {
                this.openPackage();
            }
        },
        showPackagePopup () {
            if (this.status === 1) {
                this.$emit('openPackagePopup');
            }
        },
        groupSubmit (isGroupBuying) {
            if (this.status !== 1 || this.baseInfo.head.saleEmpty === 1 || this.baseInfo.notSale) return;
            this.$emit('update:isGroupBuying', isGroupBuying);
            this.showPackagePopup();
        },
        /**
         * 打开套餐选择页
         */
        openPackage: function() {
            if (this.status === 1) {
                this.$router.push(this.getAppLink('/item/' + this.productId + '/package'));
            }
        },
        upper () {
            if (window.G && window.G.webviewBridgeReady) {
                window.G.webviewBridgeReady(bridge => {
                    bridge.callHandler('chooseShopTab', {
                        productId: this.baseInfo.productId,
                        classBrandId: this.baseInfo.classBrandParentId,
                        bookCity: this.baseInfo.bookCityCode,
                        recommendReason: ''
                    })
                })
            }
        },
        share () {
            const content = this.baseInfo.productName;
            const imageUrl = this.baseInfo.posterUrl ? this.baseInfo.posterUrl : this.baseInfo.image.productImageList[0].imageUrl;
            const posterUrl = this.baseInfo.posterUrl;
            let shareImageData = '';
            if(this.shareImageData.productId && this.shareImageData.productId == this.baseInfo.productId) {
              shareImageData = this.shareImageData.imageData;
            }
            const commison = 0;
            const commisonType = this.baseInfo.ownerType === 3 ? 2: 1;
            const mallPath = `/mall/pages/details?productId=${this.baseInfo.productId}`;
            if (window.G && window.G.webviewBridgeReady) {
                window.G.webviewBridgeReady(bridge => {
                    bridge.callHandler('share', {
                        // shareType: 3,
                        title: content,
                        content,
                        url: window.location.href,
                        shareWxAppId: "gh_53e4d148c0a4",
                        wxProgramImageURL: posterUrl,
                        wxProgramImageBase64: shareImageData,
                        wxProgramDesc: content,
                        wxProgramPath: mallPath,
                        imageurl: imageUrl,
                        bigImageBitmapBase64: shareImageData,
                        shareCommison: commison,
                        sharecommisonType: commisonType,
                        shareProductId: this.baseInfo.productId,
                        shareProductType: this.baseInfo.productType || '',
                        shareCategory: this.baseInfo.classBrandName || '',
                        bookCityCode: this.baseInfo.bookCityCode
                    }, null)
                })
            }
        },
        makeAppCall (telephoneNum) {
            var self = this;
            eventTrack('CLICK_INDEX_SERVICE_TEL');
            if (isIOS11App() && window.G && window.G.webviewBridgeReady) {
                window.G.webviewBridgeReady(function (bridge) {
                    bridge.callHandler('getAppVersion', {}, function (json) {
                        if (json && json.data && json.data.version && versionCmp(json.data.version, '9.32.0') >= 0) {
                            bridge.callHandler('telephoneCall', {
                                'telephoneNum': telephoneNum
                            });
                        } else {
                            self.$easyToast('尊敬的客户您好，麻烦将途牛旅游网APP升级至最新版本，或者手动拨打400服务热线，给您造成不便，敬请谅解~', {
                                className: 'tel-toast',
                                duration: 5000,
                                horizontalPosition: 'center',
                                verticalPosition: 'middle'
                            });
                        }
                    });
                });
            } else {
                location.href = 'tel:' + telephoneNum;
            }
        },
        addFavorite () {
            addFavoriteP({
                productId: this.productId,
                startPrice: this.startPrice
            }).then(res => {
                if (res && res.success && res.data && res.data.inserted) {
                    this.pageCollected = true;
                    this.favoriteMsg = '添加成功';
                    this.$store.dispatch('detail/addFavorite');
                } else if (res && res.needLogin) {
                    setTimeout(function() {
                        location.href = LOGIN_URL;
                    }, 10);
                } else {
                    this.favoriteMsg = '添加失败';
                }
                this.hideFavoriteTip();
            })
            .catch(() => {
                this.favoriteMsg = '添加失败';
                this.hideFavoriteTip();
            });
        },
        deleteFavorite () {
            deleteFavoriteP({
                productId: this.productId
            }).then(res => {
                if (res && res.success && res.data && res.data.isDeleted) {
                    this.pageCollected = false;
                    this.favoriteMsg = '取消成功';
                    this.$store.dispatch('detail/deleteFavorite');
                } else if (res && res.needLogin) {
                    setTimeout(function() {
                        location.href = LOGIN_URL;
                    }, 10);
                } else {
                    this.favoriteMsg = '取消失败';
                }
                this.hideFavoriteTip();
            })
            .catch(() => {
                this.favoriteMsg = '取消失败';
                this.hideFavoriteTip();
            });
        },
        hideFavoriteTip () {
            setTimeout(() => {
                this.favoriteMsg = '';
            }, 3000);
        },
        eventTrack,
        closeNotice() {
          this.showNotice = false;
        }
    }
}
</script>

<style lang="scss">
.detail-bottom-bar {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    padding: 0 18px 0 10px;
    display: flex;
    width: 100%;
    height: 56px;
    box-shadow: 0 -1px 1px 0 rgba(215,215,215,0.42);
    background: #fff;
    .item {
        flex: 1;
        background: #fff;
        padding-top: 12px;
        touch-action: manipulation;
        color: #999;
        text-align: center;
        &:nth-last-child(1) {
            border-right: 0;
        }
        i {
            display: block;
            color: #051B28;
            line-height: 22px;
            height: 22px;
            font-size: 22px;
            &.icon-retail-shop {
                font-size: 22px;
            }
            &.sj {
                background-repeat: no-repeat;
                background-position: center top;
                background-size: 25px;
                background-image: url(//m1.tuniucdn.com/fb2/t1/G5/M00/48/C5/Cii-slxFlKWIHofmAAABgT8C76sAATWBAP__mIAAAGe684.png);
            }
            &.icon-retail-star-click {
                color: #ff6436;
                &.collection-animate {
                    animation: collectMove 0.3s;
                    -webkit-animation: collectMove 0.3s;
                }
            }
            &.icon-retail-collection, &.icon-retail-star-click {
                position: relative;
                display: inline-block;
                :before {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translateX(-50%) translateY(-50%);
                }
            }
        }
        span {
            display: block;
            margin-top: 4px;
        }
    }
    .submit {
        flex: 3;
        height: 40px;
        margin: 8px 0 8px 10px;
        background: #32c45d;
        color: #fff;
        font-size: 18px;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
        &.disabled {
            color: #fff;
            background-color: #999;
        }
    }
    .submit-share {
        flex: 6.5;
        height: 44px;
        margin: 6px 0 6px 6px;
        display: flex;
        font-size: 18px;
        line-height: 44px;
        text-align: center;
        .left-submit {
            border-radius: 22px 0 0 22px;
            flex: 1;
            background: rgba(255, 57, 57, 0.1);
            color: #ff3939;
            &.long {
                flex: 1.5;
            }
        }
        .right-share {
            border-radius: 0 22px 22px 0;
            flex: 1;
            background: #ff3939;
            color: #fff;
        }
    }
    .group-buying {
      flex: 6.5;
      height: 44px;
      margin: 6px 0 6px 6px;
      background-image: linear-gradient(90deg, #F14E20 4%, #FF7C2B 100%);
      border-radius: 22px;
      display: flex;
      .single {
        flex: 1;
        display: flex;
        flex-direction: column;
        color: #FF6436;
        line-height: 18px;
        justify-content: center;
        align-items: center;
        background: rgba(255,255,255,0.90);
        .single-price {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          .qi {
              font-size: 10px;
          }
        }
        .single-desc {
          font-family: PingFang-SC-Regular;
          font-size: 12px;
        }
      }
      .group {
        flex: 1;
        display: flex;
        flex-direction: column;
        color: #FFF;
        line-height: 18px;
        justify-content: center;
        align-items: center;
        .group-price {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          .qi {
              font-size: 10px;
          }
        }
        .group-desc {
          font-family: PingFang-SC-Regular;
          font-size: 11px;
        }
      }
    }
    .notice {
      position: fixed;
      bottom: 61px;
      right: 14px;
      box-sizing: border-box;
      height: 36px;
      width: 207px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 18px;
      color: #FFF;
      font-family: PingFang-SC-Regular;
      font-size: 13px;
      color: #FFF;
      display: flex;
      align-items: center;
      &::after {
        content: '';
        width: 0;
        height: 0;
        border-width: 3px 6px;
        border-style: solid;
        border-color: rgba(0, 0, 0, 0.6) transparent transparent;
        position: absolute;
        top: 36px;
        left: 138px;
      }
      .text {
        margin-left: 12px;
      }
      .close-wrap {
        height: 36px;
        width: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        .close {
          height: 14.7px;
          width: 0.5px;
          background: #FFF;
          transform: rotate(45deg);
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 14.7px;
            width: 0.5px;
            background: #FFF;
            transform: rotate(270deg);
          }
        }
      }
    }
}
.not-for-sale {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 56px;
    z-index: 11;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #ffffff;
    font-weight: 300;
    text-align: center;
    background: rgba(76,90,101,0.80);
}
.tel-popup {
    .tel-tip {
        padding: 8px 18px;
        a {
            display: inline-block;
            height: 48px;
            width: 100%;
            border: 1px solid #dcdcdc;
            border-radius: 24px;
            text-align: center;
            line-height: 48px;
            font-size: 18px;
            font-weight: 700;
            span {
                margin-left: 8px;
            }
            i {
                color: #32c45d;
                margin-right: 8px;
                display: inline-block;
                vertical-align: -4px;
                font-size: 24px;
            }
            &.white {
                font-size: 16px;
                color: #383838;
                touch-action: manipulation;
                span {
                    font-weight: 500;
                    color: #32c45d;
                }
            }
        }
    }
}
.collection-tips {
    position: fixed;
    z-index: 1;
    top: 50%;
    left: 50%;
    p {
        position: absolute;
        top: -25px;
        left: -70px;
        height: 50px;
        width: 140px;
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        line-height: 50px;
        text-align: center;
        background-color: rgba(0,0,0,0.7)
    }
}
@keyframes collectMove
{
    0% {transform:scale(0)}
    50% {transform:scale(1.2)}
    100% {transform:scale(1)}
}
@-webkit-keyframes collectMove
{
    0% {transform:scale(0)}
    50% {transform:scale(1.2)}
    100% {transform:scale(1)}
}
.tel-toast {
    left: 50%!important;
    top: 50%!important;
    transform: translateX(-50%) translateY(-50%)!important;
    font-size: 14px;
    width: 70%;
}
</style>



// WEBPACK FOOTER //
// BottomBar.vue